import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";
import { getMyPendingCollaborationsCall } from "actions/collaborationsAction";
// import { getMyPendingCollaborationsCall } from "Common/Repository";

const initialState = {
    loading: false,
    requestsList: [],
    error: null,
    requestListCurrentPage:1,
    requestListTotalPages: null,
};

const pendingRequestsSlice = createSlice({
    name: 'pendingRequests',
    initialState,
    reducers: {
        setRequestsList: (state, action) => {
            state.requestsList = action.payload;
        },
        setRequestListCurrentPage : (state, action) => {
            state.requestListCurrentPage = action?.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMyPendingCollaborationsCall.pending, (state) => {
                if (!state.requestsList.length) {
                    state.loading = true;
                }
                state.error = null;
            })
            .addCase(getMyPendingCollaborationsCall.fulfilled, (state, action) => {
                state.requestListCurrentPage = action?.payload?.data?.collaborations?.current_page;
                state.requestListTotalPages = action?.payload?.data?.collaborations?.last_page;
                state.requestsList = action.payload?.data?.collaborations?.data;
                state.loading = false;
                state.error = null;
            })
            .addCase(getMyPendingCollaborationsCall.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(logout, (state) => {
                state.requestsList = [];
            });
    },
});

export const {
    setRequestsList,
    setRequestListCurrentPage,
} = pendingRequestsSlice.actions;

export default pendingRequestsSlice.reducer;
